import $ from "jquery";
import Vars from "../../vars";
import Validation from "../classes/Validation";
import Request from "../../components/request";
import Modal from "../../components/Modal";
import Utils from "../../components/utils";

class Payment {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $(),
        $modal   : $(),
        $form    : $(),
        $pay     : $(),
        $approve : $(),
        $cancel  : $()
    };

    _const = {
        entities : 'payments',
        entity   : 'payment',
        id       : 'id'
    };

    _args = {
        page   : '',
        title  : '',
        number : ''
    };

    _utils = {
        validation : {}
    };

    _state = {
        items    : {},
        item     : {},
        bill     : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page   = args.page;
        self._args.title  = args.title  || self._args.title;
        self._args.number = args.number || self._args.number;
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _initForm = () => {
        let self = this;

        let $form = $('form[data-name="' + self._const.entity + '"]');

        let validation = new Validation({
            form : $form
        });

        $form.find('.total_price').on('update', function(){
            let price = self._state.item.price;
            let released = self._state.item.released;
            let discount = self._state.item.discount;

            if (discount && $form.find('.js-use-promocode').hasClass('checked')) {
                //price = Math.max(0, price - discount);
            }
            else {

            }
            price = Math.max(0, price - released);

            if ($(this).data('discount_type') == 'percent' && $(this).data('discount') != '') {
                price = price - price * (parseFloat($(this).data('discount')) / 100);
            }
            else if ($(this).data('discount_type') == 'fix' && $(this).data('discount') != '') {
                price = Math.max(0, price - parseFloat($(this).data('discount')));
            }

            if (($(this).data('discount_type') == 'percent' || $(this).data('discount_type') == 'fix') && $(this).data('discount') != ''){
                let $message = $form.find('input[name="payment[promocode]"]').next('.form-field__message');
                if (!$message.children('.result').length)
                    $form.find('input[name="payment[promocode]"]').next('.form-field__message').append(
                        $('<p/>')
                            .text('Стоимость со скидкой: ' + ifacade_format_price(price) + ' руб.')
                            .addClass('result')
                    );
            }

            if ($form.find('.js-use-balance').hasClass('checked')){
                $form.find('.balance__used span').text(ifacade_format_price(Math.min(self._state.item.balance, price)));
                price = Math.max(0, price - self._state.item.balance);
            }
            else {
                $form.find('.balance__used span').text(ifacade_format_price(0));
            }

            if ($form.find('.js-use-released').hasClass('checked')){
                $form.find('.released__used span').text(ifacade_format_price(Math.min(self._state.item.released, price)));
                price = Math.max(0, price - self._state.item.released);
            }
            else {
                $form.find('.released__used span').text(ifacade_format_price(0));
            }

            $form.find('.total_price span').text(ifacade_format_price(price));
        });

        $form.find('.js-use-balance').unbind('click').on('click', function(e){
            e.preventDefault();

            let $inputs = $(this).find('input[type=hidden]');
            if ($(this).hasClass('checked')) {
                $inputs.eq(0).prop('disabled', false);
                $inputs.eq(1).prop('disabled', true);
                $(this).removeClass('checked');

                $form.find('.total_price').trigger('update');
            }
            else {
                $inputs.eq(0).prop('disabled', true);
                $inputs.eq(1).prop('disabled', false);
                $(this).addClass('checked');

                $form.find('.total_price').trigger('update');
            }
        });

        $form.find('.js-use-released').unbind('click').on('click', function(e){
            e.preventDefault();

            let $inputs = $(this).find('input[type=hidden]');
            if ($(this).hasClass('checked')) {
                $inputs.eq(0).prop('disabled', false);
                $inputs.eq(1).prop('disabled', true);
                $(this).removeClass('checked');

                $form.find('.total_price').trigger('update');
            }
            else {
                $inputs.eq(0).prop('disabled', true);
                $inputs.eq(1).prop('disabled', false);
                $(this).addClass('checked');

                $form.find('.total_price').trigger('update');
            }
        });

        $form.find('.js-use-promocode').unbind('click').on('click', function(e){
            e.preventDefault();

            let $inputs = $(this).find('input[type=hidden]');
            if ($(this).hasClass('checked')) {
                $inputs.eq(0).prop('disabled', false);
                $inputs.eq(1).prop('disabled', true);
                $(this).removeClass('checked');

                $form.find('.input[data-name="promocode"]').slideUp();

                $form.find('.total_price')
                    .data('discount_type', '')
                    .data('discount', '')
                    .trigger('update');
            }
            else {
                $inputs.eq(0).prop('disabled', true);
                $inputs.eq(1).prop('disabled', false);
                $(this).addClass('checked');

                $form.find('.input[data-name="promocode"]').slideDown();
                if ($form.find('.input[data-name="promocode"] input').val() != '') {
                    $form.find('.input[data-name="promocode"] input').trigger('keyup');
                }
            }
        });

        let pcRun = false;
        $form.find('input[name="payment[promocode]"]').on('keyup', function(){
            clearTimeout(pcRun);
            let $input = $(this);
            const value = $input.val();
            $input.next('.form-field__message').text('').slideUp();
            $form.find('.total_price')
                .data('discount_type', '')
                .data('discount', '')
                .trigger('update');

            pcRun = setTimeout(function(){
                if (value.length < 6) {
                    $input.next('.form-field__message').text('Вы ввели некорректный промокод').hide().removeClass('hidden').addClass('error').slideDown();
                }
                else {
                    loader.increase();

                    Request.send({
                        path : '/api/promocodes/' + value,
                        data : {
                            package : self._state.item.package.id
                        },
                        done : function(response) {
                            loader.decrease();

                            if (response.error){
                                if (response.error.fields && response.error.fields.promocode){
                                    $input.next('.form-field__message').text(response.error.fields.promocode).hide().removeClass('hidden').addClass('error').slideDown();
                                    return;
                                }

                                $input.next('.form-field__message').text('Ошибка при вводе промокода').hide().removeClass('hidden').addClass('error').slideDown();
                                return;
                            }

                            if (response.promocode){
                                let promocode = response.promocode;

                                let text = 'Промокод применен. Скидка ';
                                if (promocode.discount_type == 'percent') {
                                    text += promocode.discount + '%';
                                }
                                if (promocode.discount_type == 'fix') {
                                    text += promocode.discount + ' руб.';
                                }

                                $input.next('.form-field__message').html('<p>' + text + '</p>').hide().removeClass('hidden').removeClass('error').slideDown();

                                $form.find('.total_price')
                                    .data('discount_type', promocode.discount_type)
                                    .data('discount', promocode.discount)
                                    .trigger('update');
                            }
                        }
                    });
                }
            }, 1000);
        });

        $form.find('input[type="tel"]').mask("+7 (999) 99-99-999");
        $form.find('[name="payment[method]"]').change(function(){
            const value = $(this).val();

            $form.find('.additional > div').each(function(){
                $(this).hide();
                $(this).find('input').removeAttr('required');
            });

            $form.find('.additional .' + value).each(function(){
                $(this).show();
                $(this).find('input').attr('required', 'required');
            });

            if (value == 'cashless') {
                if ('bill_id' in self._state.item.options) {
                    if ('company' in self._state.item.options) {
                        $form.find('.cashless input[name="payment[company]"]').val(self._state.item.options.company);
                    }
                    if ('inn' in self._state.item.options) {
                        $form.find('.cashless input[name="payment[inn]"]').val(self._state.item.options.inn);
                    }
                    if ('ogrn' in self._state.item.options) {
                        $form.find('.cashless input[name="payment[ogrn]"]').val(self._state.item.options.ogrn);
                    }
                    //$form.find('.button').text('Скачать счет');
                    $form.find('.button').text('Сформировать счет');
                }
                else {
                    if (Object.keys(self._state.bill).length) {
                        if ('company' in self._state.bill.options) {
                            $form.find('.cashless input[name="payment[company]"]').val(self._state.bill.options.company);
                        }
                        if ('inn' in self._state.bill.options) {
                            $form.find('.cashless input[name="payment[inn]"]').val(self._state.bill.options.inn);
                        }
                        if ('ogrn' in self._state.bill.options) {
                            $form.find('.cashless input[name="payment[ogrn]"]').val(self._state.bill.options.ogrn);
                        }
                    }
                    $form.find('.button').text('Сформировать счет');
                }
            }
            else {
                $form.find('.button').text('Оплатить');
            }
        });

        $form.find('.cashless input').change(function(){
            $form.find('.button').text('Сформировать счет');
            $form.find('.cashless > p').hide();
        });
        $form.find('.cashless input').keyup(function(){
            $form.find('.button').text('Сформировать счет');
            $form.find('.cashless > p').hide();
        });

        $form.submit(function (e) {
            e.preventDefault();
            loader.increase();

            Request.send({
                path   : '/api/' + self._const.entities + '/' + self._args.number + '/pay',
                method : 'POST',
                data   : $(this).serialize(),
                done   : function (response) {
                    loader.decrease();

                    if (response.error) {
                        validation.showErrors(response.error);
                        return;
                    }

                    if (response.url) {
                        if (response.url.indexOf('.pdf') != -1) {
                            window.open(response.url);
                        }
                        else {
                            window.location.href = response.url;
                        }
                    }
                    else {
                        $('.aside').trigger('update');
                        self._state.item = response[self._const.entity];

                        let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                            crumbs : [
                                {
                                    title : 'Профиль',
                                    href  : '#'
                                },
                                {
                                    title : 'Мой кошелек',
                                    href  : '#cash'
                                },
                                {
                                    title : 'Мои счета',
                                    href  : '#cash/payments'
                                },
                                {
                                    title : self._args.title
                                }
                            ],
                            dropdown : null,
                            activate : null
                        });

                        self._elems.$content.html(Utils.renderProfileTemplate(self._args.page, {
                            breadcrumbs : breadcrumbs,
                            entity      : self._const.entity,
                            item        : self._state.item,
                            card        : function(entity, item){
                                return Utils.renderProfileTemplate(entity, {
                                    item : item,
                                    mode : self._args.page
                                });
                            }
                        }));

                        self._bindElements();
                        self._bindUI();
                    }
                }
            });
        });
    };

    _initModal = () => {
        let self = this;

        let items = self._state.items.filter(function(item){
            return item.id == self._state.id;
        });
        if (!items.length) return;

        self._state.item = items[0];

        let fields = {
            method : {
                title      : 'Способ оплаты',
                type       : 'select',
                name       : 'name',
                required   : true,
                value      : null,
                options    : ifacade.constants.payments.methods
            },
            phone : {
                title  : 'Номер мобильного телефона',
                type   : 'phone',
                hidden : true
            }
        };

        self._elems.$modal = new Modal({
            title   : 'Оплата по счету №' + self._args.number,
            content : Utils.renderProfileTemplate('form', {
                item   : self._state.item,
                entity : self._const.entity,
                fields : fields,
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Оплатить',
                        type  : 'submit'
                    },
                    two : null
                }
            }),
            closingConfirmation: true,
            confirm : function(args) {
                self._bindConfirm(args);
            }
        });

        self._elems.$form = self._elems.$modal.find('form');
        if (!self._elems.$form.length) return;

        self._setValidation();
    };

    _bindConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let errors = $form.find('.form-field.error').length;
        if (errors) return;

        Request.send({
            path   : '/api/' + self._const.entities + '/' + self._args.number + '/pay',
            method : 'POST',
            data   : $form.serialize(),
            done   : function (response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return;
                }

                if (response.url) {
                    window.location.href = response.url;
                }
                $('.aside').trigger('update');
                $modal.trigger('close');
            }
        });
    };

    _bindElements = () => {
        let self = this;

        if (!self._elems.$content.length) self._elems.$content = $('.content');
        if (!self._elems.$content.length) return;

        self._elems.$pay = self._elems.$content.find('.js-payment-pay');
        self._elems.$approve = self._elems.$content.find('[data-action="approve"]');
        self._elems.$cancel = self._elems.$content.find('[data-action="cancel"]');
    };

    _bindPay = () => {
        let self = this;
        if (!self._elems.$pay.length) return;

        self._elems.$pay.unbind('click').on('click', function(e){
            e.preventDefault();

            self._initModal();
        });
    };

    _bindApprove = () => {
        let self = this;
        if (!self._elems.$approve.length) return;

        self._elems.$approve.unbind('click').on('click', function(e){
            e.preventDefault();

            loader.increase();

            Request.send({
                path : 'api/' + self._const.entities + '/' + $(this).data('id') + '/approve',
                done : function(){
                    loader.decrease();

                    self._list();
                }
            })
        });
    };

    _bindCancel = () => {
        let self = this;
        if (!self._elems.$cancel.length) return;

        self._elems.$cancel.unbind('click').on('click', function(e){
            e.preventDefault();

            loader.increase();

            Request.send({
                path : 'api/' + self._const.entities + '/' + $(this).data('id') + '/cancel',
                done : function(){
                    loader.decrease();

                    self._list();
                }
            })
        });
    };

    _bindUI = () => {
        let self = this;
        if (!self._elems.$content.length) return;

        self._bindPay();
        self._bindApprove();
        self._bindCancel();
    };

    _list = () => {
        let self = this;

        Request.send({
            path: '/api/pages/' + self._const.entities,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items = response[self._const.entities];
                self._state.item  = {};
                self._state.bill  = {};

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : 'Мой кошелек',
                            href  : '#cash'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    title    : self._args.title,
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._args.page, {
                    breadcrumbs : breadcrumbs,
                    view        : Vars.view.tile,
                    columns     : 3,
                    entity      : self._const.entity,
                    entities    : self._const.entities,
                    actions     : false,
                    group       : false,
                    items       : self._state.items,
                    item_id     : self._const.id,
                    detail      : false,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate(self._const.entity, {
                            [self._const.entity] : item,
                            mode                 : self._args.page
                        });
                    }
                }));

                self._bindElements();
                self._bindUI();
            },
            fail : function() {
                loader.decrease();
                window.location.href = '/profile'
            }
        });
    };

    _item = () => {
        let self = this;

        loader.increase();
        Request.send({
            path : '/api/pages/' + self._const.entities + '/' + self._args.number,
            done : function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item  = response[self._const.entity];
                self._state.bill  = response.lastBill ? response.lastBill : {};
                self._state.items = {};

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : 'Мой кошелек',
                            href  : '#cash'
                        },
                        {
                            title : 'Мои счета',
                            href  : '#cash/payments'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._args.page, {
                    breadcrumbs : breadcrumbs,
                    entity      : self._const.entity,
                    item        : self._state.item,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate(entity, {
                            item : item,
                            mode : self._args.page
                        });
                    }
                }));

                self._bindElements();
                self._bindUI();
                self._initForm();
            }
        });
    };

    _init = () => {
        let self = this;
        self._bindElements();
        if (!self._elems.$content.length) return;

        if (self._args.page === Vars.page.list) {
            self._list();
        }
        else if (self._args.page == Vars.view.item) {
            self._item();
        }
    };
}

export default Payment;